import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {useQuery} from 'react-query'
import {KTSVG} from '../../../_metronic/helpers'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {Dropdown4} from '../../../_metronic/partials'
import {
  ListsWidget8,
  ListsWidget9,
  ListsWidget3,
  StatisticsWidget5,
  MixedWidget7,
  MixedWidget16,
} from '../../../_metronic/partials/widgets'
import {
  getDashboardData,
  getDashboardRedeemption,
  getDashboardSelfCare,
  getDashboardtransaction,
} from '../../modules/services/dashboard.service'
import {MixedWidget17} from '../../../_metronic/partials/widgets/mixed/MixedWidget17'
import {generatedReport, getDeptTot, getGrafik} from '../../modules/services/userprofile.service'
import {convertToRupiah} from '../../../_metronic/helpers/currency'

const dashboardBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
]

const DashboardPage = () => {
  useEffect(() => {
    // We have to show toolbar only for dashboard page
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  const [search, setSearch] = useState('')
  const [searchRedeemption, setSearchRedeemption] = useState('')
  const {data, isLoading} = useQuery(['getDashboardData'], async () => await getDashboardData())
  const {data: datas, isLoading: loading} = useQuery(
    ['getDashboardSelfCare'],
    async () => await getDashboardSelfCare()
  )
  const {data: transactionData} = useQuery(
    ['getDashboardTransaction', search],
    async () => await getDashboardtransaction(search)
  )
  const {data: redeemptionData} = useQuery(
    ['getDashboardRedeemption', searchRedeemption],
    async () => await getDashboardRedeemption(searchRedeemption)
  )

  const {data: budgetTotal} = useQuery(['getDashboardBudgetTotal'], async () => await getDeptTot())
  const {data: grafik} = useQuery(['getDashboardGrafik'], async () => await getGrafik())
  const {data: reportData} = useQuery(['getDashboardReport'], async () => await generatedReport())
  const mappingDept =
    grafik?.department?.map((item: any) => {
      return {
        x: item?.deptName,
        y: item?.generated,
      }
    }) ?? []
  const mappingCampaign =
    grafik?.campaign?.map((item: any) => {
      return {
        x: item?.name,
        y: item?.generated,
      }
    }) ?? []
  const mappingRewards =
    grafik?.reward?.map((item: any) => {
      return {
        x: item?.name.substring(0, 15),
        y: item?.redeemed,
      }
    }) ?? []
  const transactions = transactionData?.transaction ?? []
  const transactions1 = transactionData?.t_active_member ?? []
  const transactions2 = transactionData?.t_member ?? []
  const productMost = transactionData?.products ?? []

  const redemptions = redeemptionData?.redemptions ?? []
  const rewardsTop = redeemptionData?.rewardTop5 ?? []
  const rewards = redeemptionData?.rewardStats ?? []
  const mappingXY =
    datas?.selfcare?.map((item: any) => {
      return {
        x: item?.name,
        y: item?.ongoingPercentage,
      }
    }) ?? []

  const labelPersona = data?.persona?.label ?? []
  const percentPersona = data?.persona?.percent.map((e: any) => Math.round(e)) ?? []

  const labelActive = data?.activeStatus?.label ?? []
  const percentActive = data?.activeStatus?.percent.map((e: any) => Math.round(e)) ?? []

  const percentGender = data?.gender?.percent.map((e: any) => Math.round(e)) ?? []
  const countGender = data?.gender?.count ?? []

  const compositionGender = data?.gender?.composition ?? {}
  const totalMember = data?.total ?? 0
  return (
    <>
      {/* begin::Row */}
      <div className='row gy-5 g-xl-7'>
        {/* begin::Col */}
        <div className='col-xxl-12'>
          {/* <TablesWidget9 className='card-xxl-stretch mb-5 mb-xl-8' /> */}
          <StatisticsWidget5
            className='card-xl-stretch mb-xl-8'
            svgIcon='/media/icons/duotune/art/art005.svg'
            color='greens'
            iconColor='white'
            title='Total Members'
            description='Members'
            value={totalMember}
          />
        </div>
        {/* end::Col */}
      </div>
      {/* end::Row */}

      {/* begin::Row */}
      <div className='row gy-5 g-xl-8'>
        {/* begin::Col */}
        <div className='col-xxl-4'>
          {!isLoading && (
            <MixedWidget7
              className='card-xl-stretch mb-xl-8'
              chartColor='primary'
              chartHeight='300px'
              title='Persona Composition'
              label={labelPersona}
              value={percentPersona}
            />
          )}
        </div>
        {/* end::Col */}
        {/* begin::Col */}
        <div className='col-xxl-4'>
          {!isLoading && (
            <ListsWidget9
              className='card-xxl-stretch mb-xl-8'
              compositionGender={compositionGender}
              percent={percentGender}
              count={countGender}
            />
          )}
        </div>
        {/* end::Col */}
        {/* begin::Col */}
        <div className='col-xxl-4'>
          {/* <ListsWidget4 className='card-xxl-stretch mb-5 mb-xl-8' /> */}
          {!isLoading && (
            <MixedWidget7
              className='card-xl-stretch mb-xl-8'
              chartColor='primary'
              chartHeight='300px'
              title='Active Members'
              label={labelActive}
              value={percentActive}
            />
          )}
        </div>
        {/* end::Col */}
      </div>
      {/* end::Row */}
      {/* begin::Row */}
      <div className='row gy-5 g-xl-8'>
        {/* begin::Col */}
        <div className='col-xl-12'>
          {!loading && (
            <MixedWidget16
              className='card-xl-stretch mb-xl-8'
              chartColor='primary'
              chartHeight='300px'
              title='Self Care Progress'
              value={mappingXY}
            />
          )}
        </div>
        {/* end::Col */}
      </div>
      {/* end::Row */}
      {/* start new dashboard department */}
      <div className='card col-xl-12  '>
        <div className='card-header border-0'>
          <h3 className='card-title fw-bold text-dark'>Overview </h3>
          <div className='card-toolbar'>
            {/* begin::Menu */}
            <button
              type='button'
              className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
              data-kt-menu-trigger='click'
              data-kt-menu-placement='bottom-end'
              data-kt-menu-flip='top-end'
            >
              <KTSVG path='/media/icons/duotune/general/gen024.svg' className='svg-icon-2' />
            </button>
            <Dropdown4 SetSearch={setSearch} />
            {/* end::Menu */}
          </div>
        </div>
        <div className='row g-5 m-5 g-xl-12'>
          <div className='col-xl-5'>
            <StatisticsWidget5
              className='card-xl-stretch mb-xl-8'
              svgIcon='/media/icons/duotune/ecommerce/ecm008.svg'
              color='blues'
              iconColor='white'
              title={`${new Intl.NumberFormat('en-ID', {
                style: 'currency',
                currency: 'IDR',
              }).format(budgetTotal?.data?.totalBudget ?? 0)}`}
              // title='IDR 100.000.000'
              description='Total Budget'
            />
          </div>
          <div className='col-xl-7'>
            <StatisticsWidget5
              className='card-xl-stretch mb-xl-8'
              svgIcon='/media/icons/duotune/ecommerce/ecm008.svg'
              color='reds'
              iconColor='white'
              // title={transactions[0]?.value ?? 0}
              title={`${budgetTotal?.data?.percentage ?? 0} %`}
              description='Budget Spending Propotion'
            />
          </div>
        </div>
        <div className='card-header border-0'>
          <h3 className='card-title fw-bold text-dark'>Points</h3>
        </div>
        <div className='row g-5 m-5 g-xl-12'>
          <div className='col-xl-6'>
            <StatisticsWidget5
              className='card-xl-stretch mb-xl-8'
              svgIcon='/media/icons/duotune/ecommerce/ecm008.svg'
              color='greens'
              iconColor='white'
              title={`${convertToRupiah(reportData?.activePointGenerated)} PTS`}
              // title='100.500 PTS'
              description='Total Active Points'
            />
          </div>
          <div className='col-xl-6'>
            <StatisticsWidget5
              className='card-xl-stretch mb-xl-8'
              svgIcon='/media/icons/duotune/ecommerce/ecm008.svg'
              color='greens'
              iconColor='white'
              title={`${convertToRupiah(reportData?.activePointGeneratedThisPeriod)} PTS`}
              // title='13.000 PTS'
              description='Generated Point This Period'
            />
          </div>
          <div className='col-xl-6'>
            <StatisticsWidget5
              className='card-xl-stretch mb-xl-8'
              svgIcon='/media/icons/duotune/ecommerce/ecm008.svg'
              color='greens'
              iconColor='white'
              // title={transactions1[2]?.value ?? 0}
              title={`${convertToRupiah(reportData?.redeemedPoint)} PTS`}
              // title='70.000 PTS'
              description='Total Redeemed Points'
            />
          </div>
          <div className='col-xl-6'>
            <StatisticsWidget5
              className='card-xl-stretch mb-xl-8'
              svgIcon='/media/icons/duotune/ecommerce/ecm008.svg'
              color='greens'
              iconColor='white'
              // title={transactions1[2]?.value ?? 0}
              title={`${convertToRupiah(reportData?.redeemedPointThisPeriod)} PTS`}
              // title='21.000 PTS'
              description='Redemeed Point This Period'
            />
          </div>
          <div className='col-xl-6'>
            <StatisticsWidget5
              className='card-xl-stretch mb-xl-8'
              svgIcon='/media/icons/duotune/ecommerce/ecm008.svg'
              color='greens'
              iconColor='white'
              // title={transactions1[2]?.value ?? 0}
              title={`${convertToRupiah(reportData?.expiredGenerated)} PTS`}
              // title='50.000 PTS'
              description='Total Expired Points'
            />
          </div>
          <div className='col-xl-6'>
            <StatisticsWidget5
              className='card-xl-stretch mb-xl-8'
              svgIcon='/media/icons/duotune/ecommerce/ecm008.svg'
              color='greens'
              iconColor='white'
              // title={transactions1[2]?.value ?? 0}
              // title='12.000 PTS'
              title={`${convertToRupiah(reportData?.expiredGeneratedThisPeriod)} PTS`}
              description='Point that will Expired This Period'
            />
          </div>
        </div>
        <div className='card-header border-0'>
          <h3 className='card-title fw-bold text-dark'>Performance</h3>
        </div>
        <div className='row g-5 mt-5 mx-5 g-xl-12'>
          <div className='col-xl-4'>
            <MixedWidget17
              className='card-xl-stretch'
              chartColor='primary'
              chartHeight='300px'
              title='Department'
              value={mappingDept}
            />
          </div>
          <div className='col-xl-4'>
            <MixedWidget17
              className='card-xl-stretch'
              chartColor='primary'
              chartHeight='300px'
              title='Campaigns'
              value={mappingCampaign}
            />
          </div>
          <div className='col-xl-4'>
            <MixedWidget17
              className='card-xl-stretch'
              chartColor='primary'
              chartHeight='300px'
              title='Rewards'
              value={mappingRewards}
            />
          </div>
        </div>
      </div>
      {/* end new dashboard */}
      <div className='card col-xl-12  mt-8'>
        <div className='card-header border-0'>
          <h3 className='card-title fw-bold text-dark'>Transaction Customer Overview </h3>
          <div className='card-toolbar'>
            {/* begin::Menu */}
            <button
              type='button'
              className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
              data-kt-menu-trigger='click'
              data-kt-menu-placement='bottom-end'
              data-kt-menu-flip='top-end'
            >
              <KTSVG path='/media/icons/duotune/general/gen024.svg' className='svg-icon-2' />
            </button>
            <Dropdown4 SetSearch={setSearch} />
            {/* end::Menu */}
          </div>
        </div>
        <div className='row g-5 m-5 g-xl-12'>
          <div className='col-xl-4'>
            <StatisticsWidget5
              className='card-xl-stretch mb-xl-8'
              svgIcon='/media/icons/duotune/ecommerce/ecm008.svg'
              color='blues'
              iconColor='white'
              title={transactions1[2]?.value ?? 0}
              description='Customer Success Transacted'
            />
          </div>
          <div className='col-xl-4'>
            <StatisticsWidget5
              className='card-xl-stretch mb-xl-8'
              svgIcon='/media/icons/duotune/ecommerce/ecm008.svg'
              color='greens'
              iconColor='white'
              title={transactions[0]?.value ?? 0}
              description='Success Transacted'
            />
          </div>
          <div className='col-xl-4'>
            <StatisticsWidget5
              className='card-xl-stretch mb-xl-8'
              svgIcon='/media/icons/duotune/ecommerce/ecm008.svg'
              color='reds'
              iconColor='white'
              title={transactions2[0]?.value ?? 0}
              description='Average Transactions From Customers Success Transactions'
            />
          </div>
          <div className='col-xl-4'>
            <StatisticsWidget5
              className='card-xl-stretch mb-xl-8'
              svgIcon='/media/icons/duotune/ecommerce/ecm008.svg'
              color='reds'
              iconColor='white'
              title={new Intl.NumberFormat('en-ID', {style: 'currency', currency: 'IDR'}).format(
                transactions[1]?.value ?? 0
              )}
              description='Total Members Sales'
            />
          </div>
          <div className='col-xl-4'>
            <StatisticsWidget5
              className='card-xl-stretch mb-xl-8'
              svgIcon='/media/icons/duotune/ecommerce/ecm008.svg'
              color='blues'
              iconColor='white'
              title={transactions1[2]?.value ?? 0}
              description='Active Members'
            />
          </div>
          <div className='col-xl-4'>
            <StatisticsWidget5
              className='card-xl-stretch mb-xl-8'
              svgIcon='/media/icons/duotune/ecommerce/ecm002.svg'
              color='greens'
              iconColor='white'
              title={transactions1[0]?.value ?? 0}
              description='Average Transactions From Active Customers'
            />
          </div>
          <div className='col-xl-4'>
            <StatisticsWidget5
              className='card-xl-stretch mb-xl-8'
              svgIcon='/media/icons/duotune/ecommerce/ecm008.svg'
              color='greens'
              iconColor='white'
              title={new Intl.NumberFormat('en-ID', {style: 'currency', currency: 'IDR'}).format(
                transactions2[1]?.value ?? 0
              )}
              description='Average Spending/Members'
            />
          </div>
          <div className='col-xxl-8'>
            <ListsWidget8
              className='card-xl-stretch mb-5 mb-xl-6'
              title='Most Popular Product'
              product={productMost}
            />
          </div>
        </div>
      </div>

      <div className='card col-xl-12 mt-8 '>
        <div className='card-header border-0'>
          <h3 className='card-title fw-bold text-dark'>Redemption Customer Overview</h3>
          <div className='card-toolbar'>
            {/* begin::Menu */}
            <button
              type='button'
              className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
              data-kt-menu-trigger='click'
              data-kt-menu-placement='bottom-end'
              data-kt-menu-flip='top-end'
            >
              <KTSVG path='/media/icons/duotune/general/gen024.svg' className='svg-icon-2' />
            </button>
            <Dropdown4 SetSearch={setSearchRedeemption} />
            {/* end::Menu */}
          </div>
        </div>
        <div className='row g-5 m-5 g-xl-12'>
          <div className='col-xl-4'>
            <StatisticsWidget5
              className='card-xl-stretch mb-xl-8'
              svgIcon='/media/icons/duotune/ecommerce/ecm008.svg'
              color='blues'
              iconColor='white'
              title={redemptions[0]?.value ?? 0}
              description='Success Redeemed'
            />
          </div>
          <div className='col-xl-4'>
            <StatisticsWidget5
              className='card-xl-stretch mb-xl-8'
              svgIcon='/media/icons/duotune/ecommerce/ecm008.svg'
              color='greens'
              iconColor='white'
              title={redemptions[1]?.value ?? 0}
              description='Customer Success Redeemed'
            />
          </div>
          <div className='col-xl-4'>
            <StatisticsWidget5
              className='card-xl-stretch mb-xl-8'
              svgIcon='/media/icons/duotune/ecommerce/ecm008.svg'
              color='reds'
              iconColor='white'
              title={redemptions[2]?.value ?? 0}
              description='Average Transactions From Customers Success Redemption'
            />
          </div>
        </div>
        <div className='row g-5 m-5 g-xl-12'>
          <div className='col-xl-6'>
            <ListsWidget3
              className='card-xxl-stretch mb-xl-3'
              title='Rewards Claim Report'
              product={rewards}
            />
          </div>
          <div className='col-xl-6'>
            <ListsWidget8
              className='card-xl-stretch mb-5 mb-xl-8'
              title='Most Popular Rewards'
              description='Top 5 Rewards'
              product={rewardsTop}
            />
          </div>
        </div>
      </div>

      {/* begin::Row */}
      {/* <div className='row g-5 gx-xxl-8'>
        {/* begin::Col */}
      {/* <div className='col-xxl-4'>
          <MixedWidget8
            className='card-xxl-stretch mb-xl-3'
            chartColor='success'
            chartHeight='150px'
          />
        </div> */}
      {/* end::Col */}

      {/* begin::Col */}
      {/* <div className='col-xxl-8'>
          <TablesWidget5 className='card-xxl-stretch mb-5 mb-xxl-8' />
        </div> */}
      {/* end::Col */}
      {/* </div> */}
      {/* end::Row */}
    </>
  )
}

const DashboardWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={dashboardBreadCrumbs}>
        {intl.formatMessage({id: 'MENU.DASHBOARD'})}
      </PageTitle>
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
